export default __webpack_public_path__ + "static/media/CNo.67-5.5b77c60c.jpg";